import React, { Component } from "react";
import Select from "react-select";
import DatePicker from "react-datetime";
import MyLeaveDetail from "./MyLeaveDetail";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import Rodal from "rodal";
import LeaveCarryProcessStatusWarningDialog from "./new_leave/LeaveCarryProcessStatusWarningDialog";
import {
  main_url,
  getCookieData,
  calculationDate,
  validate,
  startSaving,
  calculationDate1,
  getUserId,
} from "../../utils/CommonFunction";
import {
  leaveBalanceDetails,
  leaveAllowedFiscalYear,
} from "../../utils/apiRoutes";
import { getHeaders } from "../../utils/apiHelper";
import { leaveCarryProcessStatus } from "../../utils/apiRoutes";
import DateTimeService from "../../utils/dateTimeService";

var form_validate = true;

export default class NewLeave extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: this.props.tab,
      user_info: getCookieData("user_info"),
      employeeList: [],
      leaveCategory: [],
      verifyBy: [],
      approvedBy: [],
      selectedEmployee: [],
      selectedCategory: [],
      selectedVerifyBy: [],
      selectedApproveBy: [],
      startDate: new DateTimeService().normalized,
      endDate: new DateTimeService().normalized,
      childDeliveryDate: new DateTimeService().normalized,
      reason: "",
      attachment: "",
      halfDay: 1.0,
      halfTime: "",
      showRadio: false,
      leaveBalanceDetails: [],
      user_id: getUserId("user_info"),
      leave_days1: 0,
      holidays: 0,
      leaveCarryProcessStatus: [],
      leaveAllowedFiscalYear: undefined,
      isLeaveCarryProcessStatusWarningVisible: true,
    };
  }

  componentDidMount() {
    this.getEmployeeList();
    this.leaveCategory();
    // this.getApprovedBy();
    // this.getVerifyBy();
    this.getLeaveCarryProcessStatus();
    this.getLeaveBalanceDetails();
    this.getLeaveAllowedFiscalYear();
  }

  componentDidUpdate(prevProps) {
    if (!form_validate) validate("check_form");
    if (prevProps.tab !== this.props.tab) {
      this.setState({
        tab: this.props.tab,
      });
    }
  }

  get isEarnedLeaveCarryStart() {
    if (this.state.leaveCarryProcessStatus.length === 0) return undefined;
    return this.state.leaveCarryProcessStatus.find(
      (status) => status.leave_category_id === 5
    ).in_carry_process;
  }

  get balanceBySelectedLeaveCategory() {
    if (this.state.leaveBalanceDetails.length === 0) return 0; // zero when there's no data yet
    const detail = this.state.leaveBalanceDetails.find(
      (detail) => detail.leave_category_id === this.state.selectedCategory.value
    );
    if (!detail) return 0; // Leave category is not selected at first
    return detail.total - detail.taken;
  }

  isLeaveIgnoreFiscalYear(selectCategory) {
    if (selectCategory || !Array.isArray(this.state.selectedCategory)) {
      const fiscalYearIgnoreLeaves = [3]; // Maternity Leave
      return fiscalYearIgnoreLeaves.includes(selectCategory ?? this.state.selectedCategory.value);
    }
  }

  /**
   * After earned leave carry calculation for latest fiscal year,
   * only allow new leave applications within this latest calculated fiscal year.
   * @param {object} date Moment Object
   * @returns {boolean} is allowed or not allowed
   */
  isLeaveAllowedForSelectedDate(date, selectCategory) {
    if (this.isLeaveIgnoreFiscalYear(selectCategory)) return true; // Certain leaves are allowed without fiscal year restrictions
    if (!this.state.leaveAllowedFiscalYear) return false; // better not allowed when there's no data yet

    const formatDate = new DateTimeService(date).formatDate;
    return new DateTimeService(formatDate).isDateWithin(
      this.state.leaveAllowedFiscalYear.startDate,
      this.state.leaveAllowedFiscalYear.endDate
    );
  }

  checkFiscalYearMargins(startDate, endDate) {
    const start = new Date(new DateTimeService(startDate).formatDate);
    const end = new Date(new DateTimeService(endDate).formatDate);

    const startYear = start.getFullYear();
    const endYear = end.getFullYear();
    const startMonth = start.getMonth() + 1;
    const endMonth = end.getMonth() + 1;

    if (startYear === endYear && startMonth === 3 && endMonth === 4) {
      return true;
    }
    return false;
  }

  async getLeaveCarryProcessStatus() {
    const res = await fetch(leaveCarryProcessStatus, {
      headers: getHeaders(false),
    });
    if (!res.ok) {
      return toast.error("Error: Something went wrong.");
    }
    const { data } = await res.json();
    this.setState({ leaveCarryProcessStatus: data });
  }

  async getLeaveBalanceDetails() {
    const res = await fetch(leaveBalanceDetails, {
      method: "post",
      headers: getHeaders(false),
      body: JSON.stringify({
        userIds: [this.state.user_info.user_id],
        leaveCategories: [],
      }),
    });
    if (!res.ok) {
      return toast.error("Error: Could not get leave balance details!");
    }
    const { data } = await res.json();
    this.setState({ leaveBalanceDetails: data });
  }

  async getLeaveAllowedFiscalYear() {
    const res = await fetch(leaveAllowedFiscalYear, {
      headers: getHeaders(false),
    });
    if (!res.ok) {
      return toast.error("Error: Something went wrong.");
    }
    const { data } = await res.json();
    this.setState(
      {
        leaveAllowedFiscalYear: {
          startDate: data.startDate,
          endDate: data.endDate,
        },
      },
      () => this.applyPendingAbsencePrefill()
    );
  }

  /**
   * Absence Compliance: the Pending Absence screen opens this form as /new_leave?absence_date=YYYY-MM-DD
   * so the employee does not have to pick the date again. It runs once the allowed fiscal year is
   * loaded, because the date rules need it. The leave category is still the employee's choice.
   */
  applyPendingAbsencePrefill() {
    const absenceDate = new URLSearchParams(window.location.search).get("absence_date");
    if (!absenceDate) return;
    const parsed = moment(absenceDate, "YYYY-MM-DD", true);
    if (!parsed.isValid()) return;

    const day = parsed.toDate();
    if (!this.isLeaveAllowedForSelectedDate(day)) {
      return toast.error("New leaves cannot be applied for in that fiscal year.");
    }
    this.setState({ startDate: day, endDate: day }, () => {
      this.getHolidays(day, day).then(() => this.leaveDays(day, day));
    });
  }

  async getHolidays(startDate, endDate) {
    await fetch(
      main_url +
        `leave/getHolidays/${moment
          .utc(startDate)
          .format("YYYY-MM-DD")}/${moment.utc(endDate).format("YYYY-MM-DD")}`,
      {
        headers: getHeaders(),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        let holidays = res.reduce(
          (previousValue, currentValue) =>
            previousValue + (currentValue.holidays + 1),
          0
        );
        console.log("Holidays >>>>>>>>", holidays);
        this.setState({
          holidays: holidays,
        });
      })
      .catch((error) =>
        this.setState({
          holidays: 0,
        })
      );
  }

  getEmployeeList() {
    fetch(`${main_url}main/getEmployeeWithDesignation/0`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          employeeList: data,
        });
      });
  }

  leaveCategory() {
    fetch(main_url + "leave/getLeaveCategory", {
      headers: getHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        // res.pop();
        this.setState({
          leaveCategory: res.filter((v) => v.value != 11),
        });
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  getVerifyBy() {
    // let user_id = 0;
    let category_id = 0;
    // if (this.state.tab === 1 || this.state.tab === 3) {
    //     user_id = this.state.user_id;
    // } else {
    //     var user = this.state.selectedEmployee;
    //     user_id = !Array.isArray(user) ? user.value : 0;
    // }
    var category = this.state.selectedCategory;
    category_id = !Array.isArray(category) ? category.value : 0;
    fetch(
      `${main_url}leave/getVerifyBy/${this.state.user_info.user_id}/${category_id}`,
      {
        headers: getHeaders(),
      }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        this.setState({ verifyBy: res });
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  getApprovedBy() {
    // let user_id = 0;
    let category_id = 0;
    // if (this.state.tab === 1 || this.state.tab === 3) {
    //     user_id = this.state.user_info.user_id;
    // } else {
    //     var user = this.state.selectedEmployee;
    //     user_id = !Array.isArray(user) ? user.value : 0;
    // }
    var category = this.state.selectedCategory;
    category_id = !Array.isArray(category) ? category.value : 0;
    fetch(
      `${main_url}leave/getApprovedBy/${this.state.user_info.user_id}/${category_id}`,
      {
        headers: getHeaders(),
      }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        this.setState({ approvedBy: res });
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  leaveDays(startDate, endDate) {
    let start_date = moment(startDate).format("YYYY-MM-DD");
    let end_date = moment(endDate).format("YYYY-MM-DD");
    if (start_date <= end_date) {
      if (
        this.state.selectedCategory.value == 4 ||
        this.state.selectedCategory.value == 1 ||
        this.state.selectedCategory.value == 5
      ) {
        if (this.state.selectedCategory.value == 4) {
          this.setState({
            leave_days1:
              calculationDate1(start_date, end_date) -
              parseInt(this.state.holidays),
          });
        } else {
          //Added by STHA
          let leave_days =
            calculationDate1(start_date, end_date) -
              parseInt(this.state.holidays) >
            5
              ? calculationDate(start_date, end_date)
              : calculationDate1(start_date, end_date) -
                parseInt(this.state.holidays);

          let half_day =
            calculationDate1(start_date, end_date) -
              parseInt(this.state.holidays) ===
            0
              ? 0
              : 1;
          this.setState({
            leave_days1: leave_days,
            halfDay: half_day,
          });

          //Comment by STHA
          // this.setState({
          //   leave_days1:
          //     calculationDate1(start_date, end_date) -
          //       parseInt(this.state.holidays) >
          //     5
          //       ? calculationDate(start_date, end_date)
          //       : calculationDate1(start_date, end_date) -
          //         parseInt(this.state.holidays),
          // });
        }
      } else {
        this.setState({
          leave_days1: calculationDate(start_date, end_date),
        });
      }
    } else {
      this.setState({
        leave_days1: -1,
      });
    }
  }

  handleChangeCategory = (e) => {
    // If earned leave carry calculation is finished for next fiscal year,
    // we can only take new leaves for this latest calculated fiscal year.
    // So, better set the selected date to next fiscal year start.
    if (
      !this.isLeaveAllowedForSelectedDate(this.state.startDate, e.value) ||
      !this.isLeaveAllowedForSelectedDate(this.state.endDate, e.value)
    ) {
      const defaultDate = new DateTimeService(
        this.state.leaveAllowedFiscalYear.startDate
      ).normalized;
      this.setState({
        startDate: defaultDate,
        endDate: defaultDate,
      });
      this.getHolidays(defaultDate, defaultDate).then(() => {
        this.leaveDays(defaultDate, defaultDate);
      });
    }
    // ___________________________________________________________________________________________

    this.setState(
      {
        selectedCategory: e,
        selectedVerifyBy: null,
        selectedApproveBy: null,
      },
      () => {
        this.getVerifyBy();
        this.getApprovedBy();
      }
    );
  };

  handleChangeEmployee = (e) => {
    this.setState(
      {
        selectedEmployee: e,
      },
      () => {
        this.getVerifyBy();
        this.getApprovedBy();
      }
    );
  };

  handleChangeVerifyBy = (e) => {
    this.setState({
      selectedVerifyBy: e,
    });
  };

  handleChangeApproveBy = (e) => {
    this.setState({
      selectedApproveBy: e,
    });
  };

  handleChangeChildDeliveryDate = (event) => {
    this.setState({
      childDeliveryDate: event,
    });
  };

  handleChangeStartDate = (event) => {
    if (!this.isLeaveAllowedForSelectedDate(event)) {
      if (this.checkFiscalYearMargins(event, this.state.endDate)) {
        return toast.error(
          "HRMS စနစ်စည်းမျဥ်းအရ မတ်လနှင့် ဧပြီလကို ခွင့်တစောင်တည်းပေါင်းတင်၍မရပါ။ ခွင့်၂စောင်ဖြင့် ခွဲတင်ပါရန်။"
        );
      }

      return toast.error(
        "New leaves cannot be applied for in that fiscal year."
      );
    }

    this.setState({
      startDate: event,
    });
    this.getHolidays(event, this.state.endDate).then(() => {
      this.leaveDays(event, this.state.endDate);
    });
  };

  handleChangeEndDate = (event) => {
    if (!this.isLeaveAllowedForSelectedDate(event)) {
      if (this.checkFiscalYearMargins(this.state.startDate, event)) {
        return toast.error(
          "HRMS စနစ်စည်းမျဥ်းအရ မတ်လနှင့် ဧပြီလကို ခွင့်တစောင်တည်းပေါင်းတင်၍မရပါ။ ခွင့်၂စောင်ဖြင့် ခွဲတင်ပါရန်။"
        );
      }

      return toast.error(
        "New leaves cannot be applied for in that fiscal year."
      );
    }

    this.setState({
      endDate: event,
    });
    this.getHolidays(this.state.startDate, event).then(() => {
      this.leaveDays(this.state.startDate, event);
    });
  };

  handleChangeReason = (e) => {
    this.setState({
      reason: e.target.value,
    });
  };

  handleChangeAttachment = (e) => {
    this.setState({
      selectedEmployee: e,
    });
  };

  checkFiles = (e) => {
    var files = document.getElementById("attach_file").files;
    var attachment = [];
    for (let i = 0; i < files.length; i++) {
      attachment.push(files[i]);
    }

    this.setState({
      attachment: attachment,
    });
  };
  onChangeWork(event) {
    const data = event.target.value;
    if (data === "0.5" || data === "AM" || data === "PM") {
      this.setState({
        halfDay: data,
        showRadio: true,
        halfTime: "AM",
      });
      return;
    }
    this.setState({
      halfDay: data,
      showRadio: false,
      halfTime: "",
    });
  }

  onChangeRadio(event) {
    this.setState({ halfTime: event.target.value });
  }

  hideDialog = () => {
    this.setState({
      isLeaveCarryProcessStatusWarningVisible: false,
    });
  };

  save() {
    let path = "addLeave";

    if (this.balanceBySelectedLeaveCategory === 0) {
      toast.error("Leave Balance is Zero");
    } else if (
      this.state.attachment.length == 0 &&
      this.state.selectedCategory.value != 1 &&
      this.state.selectedCategory.value != 5 &&
      this.state.selectedCategory.value != 8
    ) {
      toast.error("Please Choose Attachment File!");
    } else {
      if (validate("check_form")) {
        if (this.state.leave_days1 !== -1) {
          // if (this.state.tab === 1 || this.state.tab == 3) {
          //     user_id = this.state.user_info.user_id;
          // } else {
          //     var user = this.state.selectedEmployee;
          //     user_id = !Array.isArray(user) ? user.value : 0;
          // }

          let data = {
            user_id: this.state.user_info.user_id,
            child_delivery_date: this.state.childDeliveryDate,
            leave_start_date: this.state.startDate,
            leave_end_date: this.state.endDate,
            leave_category_id: this.state.selectedCategory.value,
            leave_days:
              moment.utc(this.state.startDate).format("YYYY-MM-DD") ===
              moment.utc(this.state.endDate).format("YYYY-MM-DD")
                ? this.state.halfDay
                : this.state.leave_days1,
            halfTime: this.state.halfTime,
            reason: this.state.reason,
            verifyBy: this.state.selectedVerifyBy.value,
            approvedBy: this.state.selectedApproveBy.value,
            application_status: 1,
            files: imagedata,
            max_days: this.balanceBySelectedLeaveCategory,
          };
          const formdata = new FormData();
          var obj = document.querySelector("#attach_file").files.length;
          for (var i = 0; i < obj; i++) {
            var imagedata = document.querySelector("#attach_file").files[i];
            formdata.append("uploadfile", imagedata);
          }
          formdata.append("leave_info", JSON.stringify(data));
          let status = 0;
          fetch(`${main_url}leave/${path}`, {
            method: "POST",
            headers: getHeaders(),
            body: formdata,
          })
            .then((res) => {
              status = res.status;
              return res.text();
            })
            .then((text) => {
              if (status === 200) {
                toast.success(text);
                window.location.replace("/leave_management");
              } else toast.error(text);
            });
        } else {
          toast.error("Start date is later than end date!");
        }
      } else {
        startSaving();
        form_validate = false;
      }
    }
  }

  render() {
    return (
      <div className="nl">
        <Rodal
          width={800}
          height={613}
          visible={
            this.isEarnedLeaveCarryStart &&
            this.state.isLeaveCarryProcessStatusWarningVisible
          }
          onClose={this.hideDialog}
        >
          <LeaveCarryProcessStatusWarningDialog hideDialog={this.hideDialog} />
        </Rodal>
        <ToastContainer
          position="top-right"
          autoClose={15000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* <ToastContainer /> */}
        <div className="col-sm-8 white-bg mt20">
          <div className="form-horizontal" id="check_form">
            <div className="form-group" style={{ marginTop: 20 }}>
              <div>
                <label className="col-sm-4">
                  Employee Name<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                {/* {
                                    this.state.tab === 1 || this.state.tab === 3 ?
                                        <input type='text' className='form-control' value={this.state.user_info.fullname} disabled />
                                        : <Select
                                            placeholder="Select Employee"
                                            options={this.state.employeeList}
                                            value={this.state.selectedEmployee}
                                            onChange={this.handleChangeEmployee}
                                            className='react-select-container checkValidate'
                                            classNamePrefix="react-select"
                                        />
                                } */}
                <input
                  type="text"
                  className="form-control"
                  value={this.state.user_info.fullname}
                  disabled
                />
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Leave Category<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                <Select
                  placeholder="Select Leave Category"
                  options={this.state.leaveCategory}
                  value={this.state.selectedCategory}
                  onChange={this.handleChangeCategory}
                  className="react-select-container checkValidate"
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Leave Balance<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control checkValidate"
                  value={this.balanceBySelectedLeaveCategory}
                ></input>
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Verify By<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                <Select
                  placeholder="Select Verify Person"
                  options={this.state.verifyBy}
                  value={this.state.selectedVerifyBy}
                  onChange={this.handleChangeVerifyBy}
                  className="react-select-container checkValidate"
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Approved By<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                <Select
                  placeholder="Select Approve Person"
                  options={this.state.approvedBy}
                  value={this.state.selectedApproveBy}
                  onChange={this.handleChangeApproveBy}
                  className="react-select-container checkValidate"
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            {this.state.selectedCategory.value == 4 ? (
              <div className="form-group">
                <div>
                  <label className="col-sm-4">
                    Child Delivery Date<span className="text-danger">*</span>
                  </label>{" "}
                </div>
                <div className="col-sm-8">
                  <DatePicker
                    className="checkValidate"
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    value={this.state.childDeliveryDate}
                    onChange={this.handleChangeChildDeliveryDate}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Start Date<span className="text-danger">*</span>
                </label>{" "}
              </div>
              <div className="col-sm-8">
                <DatePicker
                  className="checkValidate"
                  dateFormat="DD/MM/YYYY"
                  timeFormat={false}
                  value={this.state.startDate}
                  onChange={this.handleChangeStartDate}
                />
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  End Date<span className="text-danger">*</span>
                </label>{" "}
              </div>
              <div className="col-sm-8 ">
                <DatePicker
                  className="checkValidate"
                  dateFormat="DD/MM/YYYY"
                  timeFormat={false}
                  value={this.state.endDate}
                  onChange={this.handleChangeEndDate}
                />
              </div>
            </div>
            {moment.utc(this.state.startDate).format("YYYY-MM-DD") ==
            moment.utc(this.state.endDate).format("YYYY-MM-DD") ? (
              <div className="form-group">
                <div>
                  <label className="col-sm-4">
                    Leave Type<span className="text-danger">*</span>
                  </label>{" "}
                </div>
                <div
                  onChange={this.onChangeWork.bind(this)}
                  className="col-sm-8"
                >
                  <input type="radio" value={0.5} name="work" /> Half Day <br />
                  <input type="radio" value={1.0} name="work" /> Full Day
                </div>
              </div>
            ) : (
              ""
            )}
            {this.state.showRadio && (
              <div className="form-group">
                <div>
                  <label className="col-sm-4">
                    AM or PM<span className="text-danger">*</span>
                  </label>{" "}
                </div>
                <div
                  onChange={this.onChangeRadio.bind(this)}
                  className="col-sm-8"
                >
                  <input
                    type="radio"
                    value={"AM"}
                    defaultChecked={true}
                    name="halfDay"
                  />{" "}
                  AM <br />
                  <input type="radio" value={"PM"} name="halfDay" /> PM
                </div>
              </div>
            )}
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Leave Days<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control checkValidate"
                  value={
                    this.state.leave_days1 == 0 || this.state.leave_days1 == 1
                      ? this.state.halfDay
                      : this.state.leave_days1
                  }
                ></input>
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">Reason</label>
              </div>
              <div className="col-sm-8">
                <textarea
                  name="reason"
                  id="reason"
                  cols="30"
                  rows="5"
                  className="form-control checkValidate"
                  value={this.state.reason}
                  onChange={this.handleChangeReason}
                ></textarea>
              </div>
            </div>
            <div className="form-group">
              <div>
                <label htmlFor="attachment" className="col-sm-4">
                  Attachment
                </label>
              </div>
              <div className="col-sm-8">
                <input
                  type="file"
                  accept="image/*"
                  className=""
                  id="attach_file"
                  onChange={this.checkFiles}
                />
              </div>
              <div className="col-sm-8" style={{ marginTop: "10px" }}>
                Attached file တွဲပါက HRMS စနစ်မှ attach file တစ်ခုသာ တွဲရန်
                ကန့်သတ်ထားပါသဖြင့် attach တွဲမည့်ဖိုင်များကို PDF ဖိုင်ဖြင့်
                ၁ဖိုင်တည်းပေါင်းပြီးမှသာ တွဲတင်ပေးပါရန်။
              </div>
            </div>

            <div className="form-group">
              <div className="col-sm-12">
                <div className="f-right">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => this.save()}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MyLeaveDetail leaveBalanceDetails={this.state.leaveBalanceDetails} />
      </div>
    );
  }
}
